export default function createCableDispatcher(dispatch, ...translators) {
  const processor = _.over(_.flatten(translators));
  return {
    received: (subscription) => (message) => processor(message, dispatch, subscription)
  };
}
